import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import * as React from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ConfirmationModal({
  btnTitle,
  cancelBtn,
  confirmBtn,
  text,
  action
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className='flex justify-end items-center'>
      <button className="bg-blue-500 hover:bg-blue-400 text-white  py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded " onClick={handleOpen}>{btnTitle}</button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <p>{text}</p>
            <div>
              <Button onClick={() => action()}>{confirmBtn}</Button>
              <Button onClick={handleClose}>{cancelBtn}</Button>
            </div>
          </div>

        </Box>
      </Modal>
    </div>
  );
}